import { captureException } from '@sentry/react'
import axios from '@/axios-instance-node'
import { GetSubgeosSchema } from '@/features/subgeo/types.ts'
import { parseResponseData } from '@/helpers/utils'
import type { ResponseType } from '@/types.ts'

export interface HttpCreateSubgeoParams {
	payload: {
		name: string
		neighborhoodIds: string[]
	}
	params: {
		responseType: ResponseType
	}
}

export const httpCreateSubgeo = async ({
	payload,
	params
}: HttpCreateSubgeoParams) => {
	const response = await axios.post('/v1/geo-mapping-sub-geos', payload, {
		params
	})

	return parseResponseData({
		responseData: response.data,
		responseShape: GetSubgeosSchema,
		onZodError: captureException
	})
}
